import Nav from "./nav"
import Form from "./form"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Form(jQuery)
})
